import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa';
import { EventData, track } from '@/helpers/analytics';

const className = 'inline-flex items-center gap-2 font-semibold underline underline-offset-4 hover:text-primaryDark';

interface ArrowLinkProps {
    to?: string;
    href?: string;
    children: React.ReactNode;
    event?: string;
    eventData?: EventData;
}

const ArrowLink: React.FC<ArrowLinkProps> = ({ to, href, children, event, eventData }) => {
    const onClick = event ? () => track(event, eventData) : undefined;
    const content = (
        <>
            {children}
            <FaArrowRight className="h-3.5 w-3.5" aria-hidden="true" />
        </>
    );
    return href ? (
        <a href={href} target="_blank" rel="noopener noreferrer" className={className} onClick={onClick}>{content}</a>
    ) : (
        <Link to={to ?? '/'} className={className} onClick={onClick}>{content}</Link>
    );
};

export default ArrowLink;
